import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';

export type OptionSelection = {
  id: number | string;
  value: string | number;
  viewValue: string;
  color?: Hex;
};

type Hex = `#${string}`;

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'edt-editable-select-inline',
  standalone: true,
  imports: [CommonModule, OverlayModule],
  template: `
    <div cdkOverlayOrigin #trigger="cdkOverlayOrigin">
      <span
        class="view-selection status_label"
        #view_selection_value
        (click)="toogleOpen(); $event.stopImmediatePropagation()"
        [style.color]="color"
        [style.background-color]="addAlpha(color, 0.1)"
      >
        Estado
      </span>

      <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="trigger"
        [cdkConnectedOverlayOpen]="isOpen"
        cdkConnectedOverlayWidth="250"
        (overlayOutsideClick)="isOpen = false"
      >
        <div class="filter-menu">
          <ul>
            @for (item of items; track item.id) {
            <li
              (click)="changeSelection(item)"
              [style.color]="item.color"
              [style.background-color]="addAlpha(item.color ?? '#ffffff', 0.1)"
            >
              {{ item.viewValue }}
            </li>
            }
          </ul>
        </div>
      </ng-template>
    </div>
  `,
  styles: [
    `
      .view-selection {
        cursor: pointer;
      }

      .container-options {
        width: auto;
      }

      .status_label {
        border-radius: 2px;
        text-align: center;
        white-space: nowrap;
        vertical-align: initial;
        padding: 0.35em 0.6em;
        font-weight: 600;
      }

      ul {
        list-style-type: none;
        margin: 0px;
        padding: 0px;
      }

      ul li {
        border-radius: 2px;
        text-align: center;
        white-space: nowrap;
        vertical-align: initial;
        padding: 0.35em 0.6em;
        font-weight: 500;
        margin: 4px;
        cursor: pointer;
      }

      .filter-menu {
        width: 250px;
        background-color: #fff;
        padding: 10px;
        box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditableSelectInlineComponent implements AfterViewInit {
  @ViewChild('view_selection_value')
  viewSelectionElem!: ElementRef<HTMLSpanElement>;

  @Output() valueSelected = new EventEmitter<OptionSelection>();

  @Input({ required: true }) status!: string;

  @Input() color!: Hex;

  @Input() items: OptionSelection[] = [];

  isOpen: boolean = false;

  constructor() {}
  ngAfterViewInit(): void {
    this.viewSelectionElem.nativeElement.innerHTML = this.status;
  }
  toogleOpen() {
    console.log(this.isOpen);
    if (this.items.length > 0) {
      this.isOpen = !this.isOpen;
    }
  }

  changeSelection(selection: OptionSelection) {
    this.viewSelectionElem.nativeElement.innerHTML = selection.viewValue;
    this.valueSelected.emit(selection);
  }

  lightenDarkenColor(col: string, amt: number): string {
    const cloloerOut = (+('0x' + col.replace('#', '')) + amt * 0x010101)
      .toString(16)
      .padStart(6, '0');
    console.log(cloloerOut); // console
    return `#${cloloerOut}`;
  }

  ColorLuminance(hex: string, lum: number) {
    // validate hex string
    hex = hex.replace('#', '').replace(/[^0-9a-f]/gi, '');
    if (hex.length < 6) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    lum = lum || 0;

    // convert to decimal and change luminosity
    let rgb = '#',
      c,
      i;
    for (i = 0; i < 3; i++) {
      c = parseInt(hex.substr(i * 2, 2), 16);
      c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
      rgb += ('00' + c).substr(c.length);
    }

    return rgb;
  }

  addAlpha(color: string, opacity: number): string {
    // coerce values so ti is between 0 and 1.
    const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
    return color + _opacity.toString(16).toUpperCase();
  }
}
